import React from "react";

const ActivePathContext = React.createContext();
const BackToContext = React.createContext();
const DrawerContext = React.createContext();
const MenuContext = React.createContext();
const SectionContext = React.createContext();
const SideMenuContext = React.createContext();
const SideMenuWideContext = React.createContext();
const SearchTermContext = React.createContext();
const SearchInputContext = React.createContext();

export {
  ActivePathContext,
  BackToContext,
  DrawerContext,
  MenuContext,
  SectionContext,
  SideMenuContext,
  SideMenuWideContext,
  SearchTermContext,
  SearchInputContext
};
